//END CONTENT IMPORT

//this file mange ui filters logic and take care to call dataAction to trigger data update (dataAction) when necessary

import { defineStore } from "pinia";

export const useDataStore = defineStore("data", {
  state: () => ({
    dataset: null,
    decades: [],
    anchors: [],
    year: null,
  }),
  getters: {
    getDataset: (state) => state.dataset,
    getDecades: (state) => state.decades,
    getAnchors: (state) => state.anchors,
    getYear: (state) => state.year,
  },
  actions: {
    loadData(value) {
      this.decades = [];
      this.anchors = [];
      this.dataset = value;
      let tempArrDecades = [];

      for (let i = 0; i < this.dataset.length; i++) {
        const value = this.dataset[i];
        const previousValue = i > 0 ? this.dataset[i - 1] : this.dataset[i];

        const year = (value.YEAR / 10).toString().slice(0, 3);
        const previousYear = (previousValue.YEAR / 10).toString().slice(0, 3);

        if (previousYear === year) {
          tempArrDecades.push(value);
          if (i == this.dataset.length - 1) {
            this.anchors.push(Math.round(tempArrDecades[0].YEAR / 10) * 10);
            this.decades.push(tempArrDecades);
          }
        } else {
          this.anchors.push(Math.round(tempArrDecades[0].YEAR / 10) * 10);
          this.decades.push(tempArrDecades);
          tempArrDecades = [];
          tempArrDecades.push(value);
        }
      }
    },
    loadYear(value) {
      if (this.dataset) {
        this.year = this.dataset.find((item) => item.YEAR == value);
      }
    },
  },
});
